import { DesignToolsConfig } from '../config/config.schema';

const createShopConfig = (domain: string) => ({
  baseUrl: {
    bucketStorage: `https://media.${domain}`,
    mainDomainUrl: `${domain}`,
    floorImageUrl: `https://scripts.${domain}/preview3d/floor.jpeg`,
    s3BucketStorage: `https://design-tools-storage-dev.s3-accelerate.amazonaws.com`,
    restApi: `https://api.${domain}/api/design-store`,
  },
});
export const devEnv: DesignToolsConfig = {
  stage: 'dev',
  shops: {
    ex: createShopConfig('dev.truetale.io'),
    mi: createShopConfig('dev.truetale.io'),
    vt: createShopConfig('dev.truetale.io'),
    ap: createShopConfig('dev.truetale.io'),
  },
};
